module.exports = __webpack_public_path__ + "static/patient-scheduling-a6ce76e91d9f99833b49c6e91eb3fa49.png";